import styled from 'styled-components'

export const H1 = styled.h1`
  color: ${props => props.theme.primary} !important;
`

export const H2 = styled.h2`
  color: ${props => props.theme.accent1} !important;
`

export const H3 = styled.h3`
  color: ${props => props.theme.accent1};
`

export const H4 = styled.h4`
  color: ${props => props.theme.accent2};
`
